'use client';
import { useContext } from 'react';
import { BigmiContext } from '../context.js';
import { BigmiProviderNotFoundError } from '../errors/context.js';
export function useConfig(parameters = {}) {
    // biome-ignore lint/correctness/useHookAtTopLevel: part of the hook
    const config = parameters.config ?? useContext(BigmiContext);
    if (!config) {
        throw new BigmiProviderNotFoundError();
    }
    return config;
}
//# sourceMappingURL=useConfig.js.map